import _ from 'lodash';
import JsonapiClient from '@holidayextras/jsonapi-client';
import { authService } from '../../utils/auth-service';


const client = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
  header: {
    Authorization: `Bearer ${authService.getToken()}`,
  },
});

const CAMPAIGN = 'campaign';
const INVITATIONS = 'campaignInvitation';
const PERMISSIONS = 'campaignPermission';
const DISCUSSIONS = 'discussions';

const getCampaignInvitations = (email, userInfo) => {
  const options = { filter: { email }, include: [CAMPAIGN] };
  // eslint-disable-next-line
  return client.find(INVITATIONS, options)
    .then(invitations => {
      const invites = _.invokeMap(invitations, 'toJSONTree');
      const filteredInvites = _.filter(invites, { campaign: {
        owner: {
          id: userInfo.organisationId,
        },
      } });
      return filteredInvites;
    });
};

const getCampaignPermissions = (email, userInfo) => {
  const options = { filter: { email }, include: [CAMPAIGN] };
  // eslint-disable-next-line
  return client.find(PERMISSIONS, options)
    .then(perms => {
      const ps = _.invokeMap(perms, 'toJSONTree');
      const filteredPerms = _.filter(ps, { campaign: {
        owner: {
          id: userInfo.organisationId,
        },
      } });
      return filteredPerms;
    });
};

const getDiscussions = (discussionName, userInfo) => {
  // we could filter on influencer organisation here
  const options = {
    filter: {
      name: discussionName,
    },
    include: [CAMPAIGN],
    sort: ['-lastScannedDate'],
  };

  // eslint-disable-next-line
  return client.find(DISCUSSIONS, options)
    .then(perms => {
      const ps = _.invokeMap(perms, 'toJSONTree');
      const filteredPerms = _.filter(ps, p => {
        const { organisations } = p;
        const q = { id: userInfo.organisationId };
        return _.find(organisations, q);
      });

      return filteredPerms;
    });
};

module.exports = {
  getCampaignInvitations,
  getCampaignPermissions,
  getDiscussions,
};



/** WEBPACK FOOTER **
 ** ./src/components/influencer-campaigns/utils.js
 **/